<template>
  <v-dialog v-model="dialog" max-width="1000px" persistent scrollable>
    <template v-slot:activator="{ on }">
      <slot name="activator" :on="on">
        <a v-on="on">{{ formatPrice(value) }}</a>
      </slot>
    </template>
    <dialog-card @close="dialog = false">
      <v-row>
        <v-col cols="3">
          <label class="body-small">Referral</label>
          <div class="body-small--medium black--text">
            {{ referral.full_name }}
          </div>
        </v-col>
        <v-col cols="3">
          <label class="body-small">Week</label>
          <div class="body-small--medium black--text">
            {{ transaction.weekName }}
          </div>
        </v-col>
        <v-col cols="3">
          <label class="body-small">Total Transaction Amount</label>
          <div class="body-small--medium black--text">
            {{ formatPrice(transaction.total || 0) }}
          </div>
        </v-col>
      </v-row>
      <static-table-view :list="list" :headers="headers" v-model="selected">
        <template v-slot:item.amount="{ value }">
          {{ formatPrice(value || 0) }}</template
        >
      </static-table-view>
      <div slot="footer" class="d-flex">
        <close-button @click="dialog = false">Close</close-button>
      </div>
    </dialog-card>
  </v-dialog>
</template>

<script>
import {getHeaders} from "@/assets/utils/common.utils";
import transactionMixin from "@/mixins/transaction.mixin";
import CloseButton from "../ui/buttons/CloseButton.vue";
import DialogCard from "../ui/DialogCard.vue";
import StaticTableView from "../ui/StaticTableView.vue";

export default {
  props: {
    value: {
      type: [String, Number],
      default: "",
    },
    transaction: {
      type: Object,
      default: () => ({}),
    },
    referral: {
      type: Object,
      default: () => ({}),
    },
  },
  components: {
    DialogCard,
    CloseButton,
    StaticTableView,
  },
  data() {
    return {
      dialog: false,
      selected: [],
      isLoading: false,
      commission_rate: 0,
    };
  },
  mixins: [transactionMixin],
  computed: {
    list() {
      return this.transaction.history;
    },
    headers() {
      let doc = {
        client_name: "Client",
        created_at: "Date",
        amount: "Transaction Amount",
      };
      return getHeaders(doc);
    },
  },
  methods: {
    afterApplyCommission() {
      this.$emit("onUpdate");
    },
  },
};
</script>

<style></style>
